import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation} from "../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {HTH} from "../HTH";
import {HTHGameConfig} from "../HTHGameConfig";

export class HTHExtraSpinIdle implements FlowStatePresentation {

    private _flowStateController: FlowStateController;
    private readonly _presentations: SimplePresentation[];
    private _finishCalled: boolean;


    start(flowStateController: FlowStateController): void {
        HTHGameConfig.bigWinLevelPlayed = [false, false, false, false, false];
        HTHGameConfig.isBigWinLevel5Played = false;
        HTHGameConfig.lastBigWinPlayedAmount = 0;
        HTHGameConfig.isSkipped = [false, false];
        this._finishCalled = false;
        flowStateController.setSkipCallback();
        if (HTH.apiPlugin.isReplay) {
            HTH.extraSpinBet.handleReplay(() => this.completeExtraSpinIdle(flowStateController));
        } else {
            HTH.extraSpinBet.enablePromptArea(() => this.completeExtraSpinIdle(flowStateController));
        }
    }

    private completeExtraSpinIdle(flowStateController: FlowStateController): void {
        if (!this._finishCalled) {
            this._finishCalled = true;
            flowStateController.finish();
        }
    }
}